export const FORM_MODE = {
  WRITE: 'WRITE',
  READ_ONLY: 'READ_ONLY',
} as const;

export type IFormConfigurationContext = {
  mode: (typeof FORM_MODE)[keyof typeof FORM_MODE];
};
export type FormTranslateFn<TKeys extends string> = (
  key: TKeys,
  options?: Record<string, unknown>,
) => string;
